import type {
  IUserLocationChangeInitEvent,
  IUserLocationChangeInitInput,
} from '../types/clickEvents';

const userLocationChangeInit = (
  input: IUserLocationChangeInitInput,
): Omit<IUserLocationChangeInitEvent, 'event'> => ({
  linkDetails: input.linkDetails,
  locationChangeMethod: input.locationChangeMethod,
});

export default userLocationChangeInit;
